module.exports = __webpack_public_path__ + "static/media/Годишен финансов отчет на _Формопласт_АД за 2020 г.b8da1447.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Годишен финансов отчет на _Формопласт_АД за 2020 г.pdf
// module id = 107
// module chunks = 0